export const TOGGLE_SHOW_ALL_PRODUCTS = 'TOGGLE_SHOW_ALL_PRODUCTS'

export const toggleShowAllProducts = (showAll) => ({
  type: TOGGLE_SHOW_ALL_PRODUCTS,
  payload: showAll
})
